import React from 'react';

import classNames from 'classnames';

import {
    Skeleton,
    SkeletonBar,
    SkeletonCheckbox,
    SkeletonDivider,
} from 'wanderu-animations';
import { range } from 'wanderu-utils';

import styles from './FilterSkeleton.scss';

const NUMBER_OF_ROWS = 9;
function FilterSkeleton(props) {
    const { className } = props;
    return (
        <Skeleton className={classNames(className, styles.container)}>
            <SkeletonCheckbox
                barClassName={styles.firstBar}
            />
            <SkeletonCheckbox
                barClassName={styles.secondBar}
            />
            <SkeletonDivider />
            <SkeletonBar
                className={styles.bar}
            />
            <SkeletonCheckbox
                barClassName={styles.smallBar}
                checkboxClassName={styles.bigBox}
            />
            <SkeletonDivider />
            <SkeletonCheckbox
                barClassName={classNames(styles.mediumBar, styles.space)}
                checkboxClassName={styles.mediumBar}
            />
            <SkeletonBar
                className={styles.biggestBar}
            />
            <SkeletonDivider />
            <SkeletonBar
                className={styles.biggerBar}
            />
            <div className={styles.barRow}>
                <SkeletonCheckbox
                    barClassName={styles.bigBox}
                />
                <SkeletonBar
                    className={classNames(styles.box, styles.smallSpace)}
                />
            </div>
            <div className={styles.barRow}>
                <SkeletonCheckbox
                    barClassName={styles.box}
                />
                <SkeletonBar
                    className={classNames(styles.mediumBox, styles.mediumSpace)}
                />
            </div>
            <SkeletonDivider />
            <SkeletonBar
                className={classNames(styles.bigBox, styles.bottomSpace)}
            />
            {range(NUMBER_OF_ROWS).map((i) => {
                return (
                    <SkeletonCheckbox
                        barClassName={classNames(
                            styles.featuresBox,
                            { [styles.even]: i % 2 === 0 && i !== 0 },
                            { [styles.five]: i % 5 === 0 },
                            { [styles.odd]: i % 2 !== 0 && i !== 1 && i !== 5 },
                        )}
                        key={`filterSkeleton-${i}`}
                    />
                );
            })}
        </Skeleton>
    );
}

export default FilterSkeleton;
